import React from "react";

function Header() {
    return <header>
        <h1>Helper</h1>
    </header>
}

export default Header;